exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.__array-table-form-item .table thead th {\n  vertical-align: top;\n}\n.__array-table-form-item > legend {\n  cursor: pointer;\n}\n", ""]);

// exports
